import * as v from 'valibot';

import { vcAccountNumber } from '../../../../../utils/valibot/custom-types';
import { newSchema } from '../../../../../utils/valibot/schema';

export const RetailCrmCreateAccountResponseSchema = newSchema(
  'RetailCrmCreateAccountResponseSchema',
  v.object({
    success: v.boolean(),
    accountNumber: v.optional(vcAccountNumber),
    referenceId: v.optional(v.string()),
  }),
);

export type RetailCrmCreateAccountResponse = v.InferOutput<typeof RetailCrmCreateAccountResponseSchema>;
